/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { createColumnHelper } from "@tanstack/react-table";
import { FlexColumnLarge, FlexColumnSmall } from "~/components/Tables/styles";
import { ApplicationEnvironment } from "../types";

const environmentRow = createColumnHelper<ApplicationEnvironment>();
export function applicationEnvironmentsColumns() {
  return [
    environmentRow.accessor(() => null, {
      header: "Environment Name",
      cell: ({ row }) => {
        return <div>{row.original.name}</div>;
      },
      meta: FlexColumnSmall,
    }),
    environmentRow.accessor(() => null, {
      header: "Number of Resources",
      cell: ({ row }) => {
        return <div>{row.original.resourcesCount}</div>;
      },
      meta: FlexColumnLarge,
    }),
  ] as never;
}
